import URLConfig from './URLConfig';
import axiosInstance from "../util/axiosInstance";

const path = URLConfig.getBasePath();

class CartService {

    getCartItems() {
        return axiosInstance().get(path + "/cart");
    }

    updateCart(formData) {
        return axiosInstance().post(path + "/cart", formData);
    }

    deleteCart(cartId) {
        return axiosInstance().delete(path + "/cart/" + cartId);
    }

    // coupons: both return the updated cart; a bad code is a 400 with {msg}
    applyCoupon(code) {
        return axiosInstance().post(path + "/cart/coupon", { code });
    }

    removeCoupon() {
        return axiosInstance().delete(path + "/cart/coupon");
    }

    // the automatic coupons this shopper can use
    getCoupons() {
        return axiosInstance().get(path + "/cart/coupons");
    }

}

export default new CartService()
